export default [
    {
        name: 'parasolModel',
        type: 'gltfModel',
        path: 'models/parasol2.glb'
    },
    {
        name: 'textureTissu',
        type: 'texture',
        path: 'textures/parasol/textureParasolOpti.jpg'
    },
    {
        name: 'lensflare1',
        type: 'texture',
        path: 'textures/lensflare/lensflare0smooth.png'
    },
    {
        name: 'sceneModel',
        type: 'gltfModel',
        path: 'models/completeScene.glb'
    },
    {
        name: 'atlasTexture',
        type: 'texture',
        path: 'textures/atlasTexture2.jpg'
    }
]